import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Skeleton,
} from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import ItemTabel from "./ItemTabel";

export default observer(({ lstore, store, classes }) => {
  console.log("QuoteTable");
  return (
    <Table size={"small"}>
      <TableHead>
        <TableRow>
          <TableCell variant="head">SalesOrg</TableCell>
          <TableCell variant="head">Quotenr</TableCell>
          <TableCell variant="head">ShiptoName</TableCell>
          <TableCell variant="head">Validity</TableCell>
          <TableCell variant="head">conditions</TableCell>
          <TableCell variant="head">Status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {store.quoteData.ActiveQuote !== null && (
          <React.Fragment key={store.quoteData.ActiveQuote.Quotenr}>
            <TableRow
              key={"1" + store.quoteData.ActiveQuote.Quotenr}
              hover
              onClick={(e) => {
                e.preventDefault();
                lstore.activeQ = true;
              }}
              className={classes.row1}
            >
              <TableCell>{store.quoteData.ActiveQuote.Salesorg}</TableCell>
              <TableCell>
                {store.quoteData.ActiveQuote.Quotenr} (
                {store.quoteData.ActiveQuote.Doctype})
              </TableCell>
              <TableCell>{store.quoteData.ActiveQuote.Shiptoname}</TableCell>
              <TableCell>{store.quoteData.ActiveQuote.validity}</TableCell>
              <TableCell>
                {store.quoteData.ActiveQuote.Shipmentterm} /
                {store.quoteData.ActiveQuote.Incoterm1}
              </TableCell>
              <TableCell>{store.quoteData.ActiveQuote.Status}</TableCell>
            </TableRow>
            <TableRow
              key={"row2" + store.quoteData.ActiveQuote.Quotenr}
              style={{
                borderBottom: "1.5px dashed",
                marginBottom: 5,
              }}
              hover
              onClick={(e) => {
                e.preventDefault();
                lstore.activeQ = true;
              }}
            >
              <TableCell colSpan={5} variant="footer">
                <ItemTabel
                  quote={store.quoteData.ActiveQuote}
                  classesName={classes.row3}
                />
              </TableCell>
            </TableRow>
          </React.Fragment>
        )}
        {store.quoteData.loading && (
          <React.Fragment>
            <TableRow className={classes.row}>
              <TableCell>
                <Skeleton />
              </TableCell>
              <TableCell>
                <Skeleton />
              </TableCell>
              <TableCell>
                <Skeleton />
              </TableCell>
              <TableCell></TableCell>
            </TableRow>
            <TableRow
              style={{
                borderBottom: "1.5px dashed",
                marginBottom: 5,
              }}
            >
              <TableCell colSpan={4} variant="footer">
                <Table size={"small"}>
                  <TableHead>
                    <TableRow className={classes.row2}>
                      <TableCell variant="head">Mat Descr</TableCell>
                      <TableCell variant="head">Mat Code</TableCell>
                      <TableCell variant="head">Packing</TableCell>
                      <TableCell variant="head" align="right">
                        Min order Q
                      </TableCell>
                      <TableCell variant="head" align="right">
                        Price/Ton
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        <Skeleton color="secondary" />
                      </TableCell>
                      <TableCell>
                        <Skeleton />
                      </TableCell>
                      <TableCell>
                        <Skeleton />
                      </TableCell>
                      <TableCell>
                        <Skeleton />
                      </TableCell>
                      <TableCell>
                        <Skeleton />
                      </TableCell>
                      <TableCell>
                        <Skeleton />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableCell>
            </TableRow>
          </React.Fragment>
        )}
        {store.quoteData.Quotes.slice()
          .sort((a, b) => {
            var i = -1;
            if (a[lstore.sortpar] > b[lstore.sortpar]) {
              i = 1;
            }
            return i * lstore.sortdir;
          })
          .map((el, i) => (
            <React.Fragment key={el.Quotenr}>
              <TableRow
                key={"1" + el.Quotenr}
                hover
                onClick={(e) => {
                  e.preventDefault();
                  lstore.selected = i;
                }}
                className={classes.row}
              >
                <TableCell>{el.Salesorg}</TableCell>
                <TableCell>
                  {el.Quotenr} ({el.Doctype})
                </TableCell>
                <TableCell>{el.Shiptoname}</TableCell>
                <TableCell>{el.validity}</TableCell>
                <TableCell>
                  {el.Shipmentterm} / {el.Incoterm1}
                </TableCell>
                <TableCell>{el.Status}</TableCell>
              </TableRow>
              <TableRow
                key={"row2" + el.Quotenr}
                style={{
                  borderBottom: "1.5px dashed",
                  marginBottom: 5,
                }}
                hover
                onClick={(e) => {
                  e.preventDefault();
                  lstore.selected = i;
                }}
              >
                <TableCell colSpan={6} variant="footer">
                  <ItemTabel quote={el} classesName={classes.row2} />
                </TableCell>
              </TableRow>
            </React.Fragment>
          ))}
      </TableBody>
    </Table>
  );
});
